module.exports = __webpack_public_path__ + "zl2-0794c14d.png";